import { all } from 'redux-saga/effects';
import userWatcher from '../../../../user/redux/sagas/UserSaga';
import adminWatcher from '../../../../admin/dashboard/redux/sagas/AdminSaga';
import getReportWatcher from './ReportsSaga';

function* reportingSaga() {
  yield all([
    getReportWatcher(),
    userWatcher(),
    adminWatcher(),
  ]);
}

export default reportingSaga;
